// extracted by mini-css-extract-plugin
export default {"list":"styles_list__D47Eq","card":"styles_card__If3Cq"};